export default "__VITE_ASSET__hiuXIm25__"